import React, { useEffect, useState } from 'react';
import { FixedBottomBar, HeaderBox } from './MobileBookPage';
import { Box, IconButton, Typography, CircularProgress, Grid } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DivineQuotesService from '../../Services/DivineQuotes';
import { useDownloadApp } from '../../Contexts/DownloadAppContext'; 
const MobileDivineQuotes = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setShowDownloadPopup } = useDownloadApp();
  const [divineQuotes, setDivineQuotes] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const FIXED_BOTTOM_BAR_HEIGHT = 56; 

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await DivineQuotesService.getDivineQuotes("", 0, 3000);   
        setDivineQuotes(response.result?.items || []);
        setTotalRecords(response.result?.totalRecords || 0);
      } catch (error) {
        console.error("Error fetching divine quotes:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
        <HeaderBox>
          <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 16, top: 35, p: 0 }}>
            <ArrowBackIosIcon sx={{ color: "white", fontSize: '18px' }} />
          </IconButton>
          <IconButton onClick={() => navigate("/")} sx={{ position: 'absolute', left: 48, top: 35, p: 0 }}>
            <HomeOutlinedIcon sx={{ color: "white", fontSize: '24px' }} />
          </IconButton>
          <Typography variant="caption" sx={{ color: "#ffffffdd", opacity: 0.9, mb: 0.5 }}>
            {t("shrihari_tr")}
          </Typography>
          <Typography variant="h6" sx={{ color: "#ffffffdd", opacity: 0.9, fontSize: 15 }}>
            {t("Amrit_Vachan_tr")}
          </Typography>
        </HeaderBox>
        <Box sx={{
          backgroundColor: '#f0f0f0',
          padding: '8px 16px',
          textAlign: 'left',
          borderBottom: '1px solid #e0e0e0',
        }}>
          <Typography variant="body2" sx={{ color: '#555',textAlign:'center' }}>
            {t("Total_Records_tr")}: {totalRecords}
          </Typography>
        </Box>
        <Box
          sx={{
            backgroundColor: "lightgray",
            flexGrow: 1,
            overflowY: 'auto',
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            padding: '8px',
            paddingBottom: `${FIXED_BOTTOM_BAR_HEIGHT + 16}px`, 
          }}
        >
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={1}>
              {divineQuotes.map((quote:any,index:number) => (
                <Grid item xs={6} sm={4} md={3} key={quote?.id}>
                  <Box
                    onClick={()=>setShowDownloadPopup(true)}
                    component="img"
                    src={quote?.quotesThumbPath}
                    alt={`Divine Quote ${quote?.id}`}
                    sx={{
                      width: '100%',
                      height: 'auto',
                      display: 'block',
                      borderRadius: '8px',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          )}
        </Box>
        <Box
          sx={{
            position: 'sticky',
            bottom: 0,
            width: '100%',
            zIndex: 100,
          }}
        >
          {/* <FixedBottomBar /> */}
        </Box>
      </Box>
    </>
  );
};

export default MobileDivineQuotes;